import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const OutletContext = createContext(null);

export function OutletProvider({ children, staff }) {
  const [outlets, setOutlets] = useState([]);
  const [activeOutletId, setActiveOutletIdState] = useState(
    () => localStorage.getItem("boba_outlet") || ""
  );

  const setActiveOutletId = useCallback((id) => {
    if (id) localStorage.setItem("boba_outlet", id);
    else localStorage.removeItem("boba_outlet");
    setActiveOutletIdState(id || "");
  }, []);

  const refresh = useCallback(async () => {
    if (!staff) {
      setOutlets([]);
      return;
    }
    try {
      const { data } = await api.get("/outlets");
      setOutlets(data);
      if (staff.role !== "super_admin" && staff.outlet_id) {
        // Force scope to assigned outlet
        if (activeOutletId !== staff.outlet_id) setActiveOutletId(staff.outlet_id);
      } else if (staff.role === "super_admin" && !activeOutletId && data.length > 0) {
        // default to "all outlets" (empty) for super_admin
      }
    } catch {
      // ignore
    }
  }, [staff, activeOutletId, setActiveOutletId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const activeOutlet = outlets.find((o) => o.id === activeOutletId) || null;

  return (
    <OutletContext.Provider
      value={{ outlets, activeOutletId, activeOutlet, setActiveOutletId, refresh }}
    >
      {children}
    </OutletContext.Provider>
  );
}

export const useOutlet = () => useContext(OutletContext) || {};
